import { Button } from '@ds/coolshop';
import { useIntl } from 'react-intl';

type SubmitButtonProps = {
    message: string;
    fullWidth?: boolean;
    disabled?: boolean;
    loading?: boolean;
    color?: 'primary' | 'secondary';
    /** Palette the button sits on; keeps the disabled state readable on a coloured bar. */
    contrastColor?: 'primary' | 'secondary';
    /**
     * Id of the form this button submits. Required when the button is rendered outside
     * the form's DOM subtree (e.g. portalled into a dialog bar), where the implicit
     * form association of type="submit" does not apply.
     */
    form?: string;
};

function SubmitButton({
    fullWidth,
    message,
    disabled,
    loading,
    color = 'primary',
    contrastColor,
    form,
}: SubmitButtonProps): JSX.Element {
    const intl = useIntl();
    return (
        <Button
            type="submit"
            form={form}
            color={color}
            contrastColor={contrastColor}
            variant="contained"
            data-testid="submit-button"
            disabled={disabled || loading}
            loading={loading}
            fullWidth={fullWidth}
        >
            {intl.formatMessage({ id: message ?? 'submit', defaultMessage: message ?? 'Submit' })}
        </Button>
    );
}

export default SubmitButton;
